export default __webpack_public_path__ + "static/media/spinner.01777ea0.gif";